export default __webpack_public_path__ + "static/media/boniface.2e660558.png";